module.exports = __webpack_public_path__ + "img/halloween-light-medium.84633456.svg";